export { Template as EstatePlanningRecommendationQualificationStepTemplate } from './Template';
